import {Box,Button,Checkbox,Container,Link,TextField,Typography} from '@mui/material';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import React from 'react';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import Paper from '@mui/material/Paper';
import LinearProgress from '@mui/material/LinearProgress';
import { Navigate } from "react-router-dom"
import {  Grid,  } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import Textfield from '@atlaskit/textfield';
import validator from 'validator'
import DoneIcon from '@mui/icons-material/Done';
import { green, red, yellow } from '@mui/material/colors';
import CircularProgress from '@mui/material/CircularProgress';

export default class Register extends React.Component{
  constructor(){
    super()
    this.state={
      firstName:'',
      lastName:'',
      email:'',
      company:'',
      designation:'',
      password:'',
      mobileNo:'',
      PassErrorMsg:'',
      confirmpassword:'',
      authentication:true,
      modelOpen:false,
      progress:false,
      loginPage:false,
      upperCase:true,
      lowerCase:true,
      number:true,
      symbol:true,
      length:true,
      modelprogress:false,
      formErrors: {
        firstName:'',
        lastName:'',
        email:'',
        company:'',
        designation:'',
        password:'',
        mobileNo:'',
        authentication:true,
        color:'',
      },
    }
  } 
  componentDidMount=()=>{
  
  }
  onModelClick=()=>{
    this.setState({modelOpen:true})
  }
  onModelCose=()=>{
    this.setState({modelOpen:false,firstName:'',lastName:'',email:'',company:'',designation:'',password:'',mobileNo:''})
   this.setState({loginPage:true})
  }
  validateEmail=(email)=> {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  onChangeMobileNum=(evt)=>{
    const re = /^[0-9\b]+$/;
    if (evt.target.value === '' || re.test(evt.target.value)) {
      this.setState({mobileNo: evt.target.value})
    }
  }
  onSubmitClick=()=>{
   if(this.state.firstName===''||this.state.lastName===''||this.state.email===''||this.state.company===''||this.state.designation===''||
    this.state.password===''||this.state.mobileNo===''){
      alert('All Inputs Are Required')
    }else if(this.state.mobileNo.length<10){
      alert('Please enter the correct mobile number')
    }
    else if(this.state.mobileNo.length>10){
      alert('Please enter the correct mobile number')
    }
    else if(!this.validateEmail(this.state.email)){
      alert('Please Enter Valid MailId')
    }else if(this.state.password!==this.state.confirmpassword){
      alert('Password and Confirm Password mismatched')
    }
    else{
      this.setState({modelprogress:true})
      let json_data={emailId:this.state.email,mobileNo:this.state.mobileNo,firstName:this.state.firstName,lastName:this.state.lastName,
      companyName:this.state.company,password:this.state.password,saAuth:this.state.authentication?1:0,designation:this.state.designation}
      fetch(`eadmin/v1/set/user_registration`, {
      method: 'POST',
      headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      },
      body:(JSON.stringify(json_data)),
      }).then((response) => response.json())
      .then((responseJson) => {
        if(responseJson.status ){
          //alert(JSON.stringify(responseJson))
          this.setState({modelprogress:false})
         
          this.onModelClick()
        }else{
          this.setState({modelprogress:false})
          alert(responseJson.errorMsg)
        }
      }).catch((error) => {
        alert(error)
      });
    }
  }
/*validate = (value) => {
    if (validator.isStrongPassword(value, {
      minLength: 8, minLowercase: 1,
      minUppercase: 1, minNumbers: 1, minSymbols: 1
    }
    
    )) {
      this.setState({PassErrorMsg:'Is Strong Password',})
    } else {
      this.setState({PassErrorMsg:'Is Not Strong Password'})
    }
  }*/

  validateUpperCase=(value)=> {
  const regexp = /^[A-Z]/;
  const regexp2=/(?=.*[a-z])/;
  const regexp3=/(?=.*[0-9])/;
  const regexp4=/(?=.*[!@#$%^&*])/;
    if (regexp.test(value)){
      this.setState({upperCase:false})
    }
    if (regexp2.test(value)){
      this.setState({lowerCase:false})
    } 
    if (regexp3.test(value)){
      this.setState({number:false})
    } 
    if (regexp4.test(value)){
      this.setState({symbol:false})
    }
    if(value.length===8){
      this.setState({length:false})
    }
    if (validator.isStrongPassword(value, {
      minLength: 8, minLowercase: 1,
      minUppercase: 1, minNumbers: 1, minSymbols: 1
    }
    )) {
      this.setState({PassErrorMsg:'Is Strong Password',})
    } else {
      this.setState({PassErrorMsg:'Is Not Strong Password'})
    }
  }
  
  render(){
    return(
      <>
        <Paper elevation={2} sx={{ maxWidth:'800px',
          minWidth: '550px',
          maxHeight: '100%',
          margin: '100px auto',
          backgroundColor: '#FFFFFF',
          borderRadius: '25px'}}>
          {this.state.progress && <LinearProgress color="secondary"/>}
          <Box
            component="main"
            sx={{
              alignItems: 'center',
              display: 'flex',
              flexGrow: 1,
              minHeight: '100%',
              marginTop:'2%'
            }}
          >
          <Container maxWidth="sm">
            <Box sx={{ my: 3 }}>
              <Typography
                color="textPrimary"
                variant="h4"> 
               Create a new account
              </Typography>
              <Typography
                color="textSecondary"
                gutterBottom
                variant="body2"
              >
                Use your email to create a new account
              </Typography>
            </Box>
            <TextField
              fullWidth
              label="First Name *"
              margin="normal"
              onChange={(evt)=>this.setState({firstName:evt.target.value.toUpperCase()})}
              value={this.state.firstName}
              variant="outlined"
            />
            <TextField
              fullWidth
              label="Last Name *"
              margin="normal"
              variant="outlined"
              onChange={(evt)=>this.setState({lastName:evt.target.value.toUpperCase()})}
              value={this.state.lastName}
            />
            <TextField
              fullWidth
              label="Email Address *"
              margin="normal"
              type="email"
              variant="outlined"
              onChange={(evt)=>this.setState({email:evt.target.value})}
              value={this.state.email}
            />
              <TextField
              fullWidth
              label="Mobile No *"
              margin="normal"
              type="mobile No"
              variant="outlined"
              onChange={this.onChangeMobileNum}
              value={this.state.mobileNo}
            />
            <TextField
              fullWidth
              label="Occupation *"
              margin="normal"
              type="Occupation"
              variant="outlined"
              onChange={(evt)=>this.setState({designation:evt.target.value.toUpperCase()})}
              value={this.state.designation}
            />
              <TextField
              fullWidth
              label="Company Name or Self Employee *"
              margin="normal"
              type="company"
              variant="outlined"
              onChange={(evt)=>this.setState({company:evt.target.value.toUpperCase()})}
              value={this.state.company}
            />
               <pre>
            <TextField
             error={this.state.PassErrorMsg=== "Is Not Strong Password"  }
              fullWidth
              label="Password *"
              margin="normal"
              type="password"
              variant="outlined"
              onChange={(evt) =>{this.validateUpperCase(evt.target.value)
              this.setState({password:evt.target.value})}}
              value={this.state.password}
             
            /><br/> 
              {this.state.PassErrorMsg === 'Is Not Strong Password' ? <span style={{
              fontWeight: 'bold',
              color: 'red',
            }}>
            {this.state.PassErrorMsg} </span> :
            <span style={{
              fontWeight: 'bold',
              color: 'green',
            }}>
            {this.state.PassErrorMsg} </span>}<br/>
              <Grid container >
                <Grid item xs={12} sm={12} md={6}>
                {this.state.length?
                  <span style={{color:'red'}}><DoneIcon  /> 8 character Minimum </span>:
                  <span style={{color:'green'}}><DoneIcon  />8 character Minimum</span>  }
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                {this.state.number?
                  <span style={{color:'red'}}><DoneIcon  />one number </span>:
                  <span style={{color:'green'}}><DoneIcon  />one number</span>  }
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  {this.state.upperCase?
                  <span style={{color:'red'}}><DoneIcon  />one uppercase </span>:
                  <span style={{color:'green'}}><DoneIcon  />one uppercase</span>  }
                </Grid>
                <Grid item xs={12} sm={12}  md={6}>
                {this.state.lowerCase?
               <span style={{color:'red'}}><DoneIcon  />one lowercase </span>:
               <span style={{color:'green'}}><DoneIcon  />one lowercase</span>  }
                  </Grid>
                 
                  <Grid item xs={12} sm={12} md={6}>
                  {this.state.symbol?
                 <span style={{color:'red'}}> <DoneIcon  />one symbol must</span>:
                 <span style={{color:'green'}}><DoneIcon />one symbol must</span>}
                  </Grid>
              </Grid>
         
            </pre>
            <TextField
              fullWidth
              label="Confirm Password *"
              margin="normal"
              type="password"
              variant="outlined"
              onChange={(evt)=>this.setState({confirmpassword:evt.target.value})}
              value={this.state.confirmpassword}
            />
            <Box
              sx={{
                alignItems: 'center',
                display: 'flex',
                ml: -1
              }}
            >
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.authentication} 
                    onChange={(evt)=>this.setState({authentication:!this.state.authentication})}
                    value="SA Authentication"
                  />
                }
                label="SA Authentication"
              />
            </FormGroup>
            </Box>
            <Box sx={{ py: 2 }}>
              <Button
                color="primary"
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                onClick={this.onSubmitClick}>Continue
              </Button>
            </Box>
            <Typography
              color="textSecondary"
              variant="body2">Already Have an account?
                <a style={{color:'blue'}} href='/login' variant="subtitle2" underline="hover">
                  LogIn
                </a>
            </Typography>
          </Container>
        </Box>
      </Paper>
      <ModalTransition>
        {this.state.modelOpen && (
          <Modal >
            <ModalHeader>
              <ModalTitle>SA License Registeration</ModalTitle>
            </ModalHeader>
            <ModalBody>
              <ul>
              <li>Registered Successfully The Confirmation Link Is Send to Our Mail ID</li><br/>
              <li>Link is valid for 5 minutes only</li>
              </ul>
            </ModalBody>
            <ModalFooter>
              <Button appearance="primary" onClick={this.onModelCose} autoFocus>OK</Button>
            </ModalFooter>
          </Modal>
        )}
     </ModalTransition>
     <ModalTransition>
        {this.state.modelprogress && (
          <Modal >
            <ModalHeader>
              Progress
            </ModalHeader>
            <ModalBody>
            <center><CircularProgress color="success" /></center>
            </ModalBody>
          
          </Modal>
        )}
     </ModalTransition>
      { 
        this.state.loginPage && <Navigate to='/login' replace={true}/>
      }
    
    </>
    )
  }
}


